import { Action } from '@ngrx/store';
import { MethodOptionCategoryInterface } from '../../+models/MethodOptionCategory.interface';

export enum MethodOptionCategoriesActionTypes {
  LoadMethodOptionCategories = '[MethodOptionCategories] Load MethodOptionCategories',
  MethodOptionCategoriesLoaded = '[MethodOptionCategories] MethodOptionCategories Loaded',
  MethodOptionCategoriesLoadError = '[MethodOptionCategories] MethodOptionCategories Load Error',
}

export class LoadMethodOptionCategories implements Action {
  readonly type = MethodOptionCategoriesActionTypes.LoadMethodOptionCategories;

  constructor(public payload: { force?: boolean; userId: number } = { userId: null }) {}
}

export class MethodOptionCategoriesLoaded implements Action {
  readonly type = MethodOptionCategoriesActionTypes.MethodOptionCategoriesLoaded;

  constructor(public payload: { methodOptionCategories: MethodOptionCategoryInterface[] }) {}
}

export class MethodOptionCategoriesLoadError implements Action {
  readonly type = MethodOptionCategoriesActionTypes.MethodOptionCategoriesLoadError;
  constructor(public payload: Error) {}
}

export type MethodOptionCategoriesActions =
  | LoadMethodOptionCategories
  | MethodOptionCategoriesLoaded
  | MethodOptionCategoriesLoadError;
